/**
 * Finds the closest available finance term when changing credit tiers.
 * Prioritizes the currently selected term, then finds the closest available term.
 *
 * @param {number} currentTerm - The currently selected finance term
 * @param {number[]} availableTerms - Array of available terms for the new credit tier
 * @returns {number|null} The closest available term, or null if no terms available
 */
const findClosestFinanceTerm = function (currentTerm) {
  let availableTerms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (availableTerms?.length === 0) {
    return null;
  }

  // If current term is available in new tier, keep it
  if (availableTerms?.includes(currentTerm)) {
    return currentTerm;
  }

  // Find the closest term by calculating the minimum distance
  const closestTerm = availableTerms?.reduce((closest, term) => {
    const currentDistance = Math.abs(currentTerm - term);
    const closestDistance = Math.abs(currentTerm - closest);
    return currentDistance < closestDistance ? term : closest;
  }, availableTerms[0]);
  return closestTerm;
};
export { findClosestFinanceTerm as default };
